let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7Q0UC"), load("6qah4"), load("4PQXU"), load("1epse"), load("5joXW"), load("c6MKV"), load("9IyPY")]).then(() => parcelRequire('1XrYH'));